import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { SimpleResponse } from 'Types/simpleResponse'
import { ResponseCatalog, RequestParams } from 'Models'
import { BlockModel } from 'Pages/orders'

export const blockApi = {
	getAll: async (requestParams: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<BlockModel>>(`${urls.orders.block}`, {
			params: requestParams,
		})
		return res.data
	},
	deleteOne: async (id: number) => {
		const res = await axiosDS().delete<SimpleResponse>(`${urls.orders.block}/${id}`)
		return res.data
	},
}
